import { gap, opacity, spacing } from '@lamimed/pantheon';
import Image from 'next/legacy/image';
import styled from 'styled-components';

export const SlideControl = styled.div`
  cursor: pointer;
  opacity: ${opacity.hard};
  transition: opacity 0.2s ease-in-out;

  position: relative;
  transform: unset;
  top: ${spacing.large};
  display: flex;
  justify-content: end;
  ${gap(spacing.small)};
  &:hover {
    opacity: 1;
  }
`;

export const LeftSlideControl = styled(SlideControl)`
  justify-content: 'start';
`;

export const Wrapper = styled.div`
  /* NOTE: Compensates for the size of the carousel bottom controls. */
  margin-bottom: 4.5rem;
`;

export const PreviousArrow = styled(Image)`
  transform: rotate(180deg);
`;
